import type { ComponentProps, ReactNode } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type UsageReportNote = {
  term: string
  text: ReactNode
}

export type UsageReportNotesProps = ComponentProps<"details"> & {
  /** Heading of the folded block ("About the numbers"). */
  title?: string
  notes: UsageReportNote[]
}

/**
 * "About the numbers": the definitions behind a report, folded away so
 * they are there when a number is questioned and out of the way when it is
 * not. Term and explanation per row, like the report's methodology page.
 */
function UsageReportNotes(props: UsageReportNotesProps) {
  const {
    title = "About the numbers",
    notes,
    className,
    ...detailsProps
  } = props

  return (
    <details className={cn("usage-report-notes", className)} {...detailsProps}>
      <summary className="usage-report-notes-summary">{title}</summary>
      <dl className="usage-report-notes-list">
        {notes.map((note) => (
          <div key={note.term} className="usage-report-note">
            <dt>{note.term}</dt>
            <dd>{note.text}</dd>
          </div>
        ))}
      </dl>
    </details>
  )
}

export default UsageReportNotes
